//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		dataList: {}
	},
	data() {
		return {};
	}
};
